import { render, staticRenderFns } from "./MusicDashboard.vue?vue&type=template&id=8e26cac6&scoped=true&"
import script from "./MusicDashboard.vue?vue&type=script&lang=js&"
export * from "./MusicDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MusicDashboard.vue?vue&type=style&index=0&id=8e26cac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e26cac6",
  null
  
)

export default component.exports